import StatsView from "./statsView";

const StatsLayout = () => {
    return (
        <>
            <StatsView />
        </>
    );
}

export default StatsLayout;